import { Fragment } from 'react'
import { StepsInterface } from '../../../../types/steps'
import {
  Step1Client,
  Step2Apartment,
  Step3Media,
  Step4Confirmation
} from './StepComponents'
//import Payment from '../../../PayForPublish/Payment'

const Steps = ({
  stepProps: {
    baseFormStepProps,
    baseFormStepProps: { currentStep, apartment, isMobile, isConfirmed },
    classes,
    updateApartmentInfo,
    updateApartmentClientInfo,
    updateApartmentClientInfoToOverview,
    doStepBack,
    clientContactInfo,
    areUsersLoading,
    apartmentConfirmation,
    addApartmentMediaFiles,
    deleteMedia,
    reorderMedia,
    doConfirmMedia,
    files
  }
}: StepsInterface) => (
  <Fragment>
    {apartment && (
      <Fragment>
        <Step1Client
          baseFormStepProps={baseFormStepProps}
          classes={classes}
          updateApartmentClientInfo={updateApartmentClientInfo}
          updateApartmentClientInfoToOverview={updateApartmentClientInfoToOverview}
          clientContactInfo={clientContactInfo}
          areUsersLoading={areUsersLoading}
        />
        <Step2Apartment
          baseFormStepProps={baseFormStepProps}
          classes={classes}
          updateApartmentInfo={updateApartmentInfo}
        />
        <Step3Media
          baseFormStepProps={baseFormStepProps}
          currentStep={currentStep}
          apartment={apartment}
          addApartmentMediaFiles={addApartmentMediaFiles}
          deleteMedia={deleteMedia}
          reorderMedia={reorderMedia}
          doConfirmMedia={doConfirmMedia}
          files={files}
          classes={classes}
        />
        <Step4Confirmation
          baseFormStepProps={baseFormStepProps}
          classes={classes}
          apartmentConfirmation={apartmentConfirmation}
        />
        {/* <Payment
          baseFormStepProps={baseFormStepProps}
          classes={classes}
        /> */}
        { }
      </Fragment>
    )}
  </Fragment>
)

export default Steps
